import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  makeStyles,
  Card,
  CardContent,
  Typography,
  Container,
  Button,
  TextField,
  InputAdornment,
  Box,
  useMediaQuery
} from '@material-ui/core';

import { useSelector } from 'react-redux';
import LaunchIcon from '@material-ui/icons/Launch';
import SearchIcon from '@material-ui/icons/Search';
import { useRequest } from 'src/hooks';
import { Pagination, Skeleton } from '@material-ui/lab';
import defaultImages from './defaultImages';

const useStyles = makeStyles(theme => ({
  banner: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '',
    overflow: 'hidden',
    boxShadow: '0px 4px 8px rgba(255, 165, 0, 0.6)',
    borderBottom: '4px solid orange',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-50px'
    }
  },
  root: {
    margin: 0,
    padding: 0,
    backgroundColor: '#fff',
    marginTop: '25px'
  },
  // banner: {
  //   width: '100%',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   marginTop: '', // or some positive value if needed
  //   boxShadow: '0px 4px 8px rgba(255, 165, 0, 0.6)',
  //   borderBottom: '4px solid orange'
  // },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  card: {
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    transition: 'box-shadow 0.3s, transform 0.3s',
    // borderLeft: '15px solid orange',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '10px',
    textAlign: 'left',
    minHeight: '150px', // <--- replace height with minHeight
    position: 'relative',
    '&:hover': {
      boxShadow: '0 6px 8px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)'
    },
    [theme.breakpoints.down('xs')]: {
      height: 'auto'
    }
  },
  cardContent: {
    padding: theme.spacing(1),
    textAlign: 'left',
    flexGrow: 1
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'auto',
    padding: theme.spacing(1)
  },
  viewDetailsButton: {
    fontSize: '16px',
    textTransform: 'none',
    padding: 0
  },
  welcomeText: {
    fontWeight: 'bold',
    color: '#ff7504',
    margin: '20px',
    textAlign: 'center',
    padding: '15px',
    marginTop: '20px',
    fontSize: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4rem'
    }
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: '#fff',
    borderRadius: '20px',
    marginBottom: theme.spacing(2)
  },
  glowingLink: {
    paddingLeft: '10px',
    paddingRight: '10px',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#ff7504',
    animation: '$blink 1.5s infinite'
  },
  '@keyframes blink': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
}));

const https = axios.create({
  baseURL: '/api'
});

const JobPagesPublic = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [userData, setUserData] = useState({});
  const [jobsMeta, setJobsMeta] = useState(null);

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isExtraSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.down('xs')
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 6;
  const {
    portal: { token }
  } = useSelector(({ auth }) => auth);
  const req = useRequest();

  async function getJobItems() {
    try {
      const response = await axios.get(`/api/jobs/meta`);
      setJobsMeta(response.data?.jobs);
    } catch (err) {
      console.error('Error fetching jobs meta:', err);
    }

    const { success, error, data } = await req.post('/jobs/get-items');
    if (success) setData(data);
    else console.error(error);
  }

  const handleCardClick = job => {
    window.location.href = `/job-details/${job.ixJob}`;
  };
  const handleLoginClick = () => {
    console.log(jobsMeta)
    window.location.href = `/portal/${jobsMeta?.cdBiz}/${jobsMeta?.cdPortal}/login`
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const filteredData = (data || []).filter(
    job =>
      job.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.Particulars.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    getJobItems();
  }, []);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const placeholders = Array(itemsPerPage - paginatedData.length).fill(null);

  // if (loading) {
  //   return (
  //     <Container>
  //       <Skeleton
  //         variant="rect"
  //         width="100%"
  //         height={300}
  //         style={{ marginBottom: '20px' }}
  //         animation="wave"
  //       />
  //       <Skeleton
  //         variant="text"
  //         width="60%"
  //         height={40}
  //         style={{ margin: '20px auto' }}
  //         animation="wave"
  //       />
  //       <Skeleton
  //         variant="rect"
  //         width="100%"
  //         height={50}
  //         style={{ marginBottom: '20px', borderRadius: '30px' }}
  //         animation="wave"
  //       />
  //       <div className={classes.gridContainer}>
  //         {Array.from({ length: itemsPerPage }).map((_, index) => (
  //           <Skeleton
  //             key={index}
  //             variant="rect"
  //             width="100%"
  //             height={300}
  //             style={{ borderRadius: '16px' }}
  //             animation="wave"
  //           />
  //         ))}
  //       </div>
  //     </Container>
  //   );
  // }

  return (
    <div className={classes.root}>
      <Card
        style={{
          width: '100%',
          height: '30vh',
          maxHeight: '300px',
          minHeight: '200px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          position: 'relative',
          marginTop: '-79px'
        }}
      >
        <img
          src={require(isSmallScreen
            ? './bannermobile.png'
            : './NewBanner.png')}
          alt="Job Thugmbnail"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'fill'
          }}
        />
      </Card>

      <Container>
        <Typography variant="h1" className={classes.welcomeText}>
          Start Where Change Happens
        </Typography>

        <Typography
          variant="h4"
          align="center"
        >
          {' '}
          Already have an account?
          <a
            onClick={() =>handleLoginClick()}
            className={classes.glowingLink}
          >
            Login
          </a>
        </Typography>
        <Typography
          variant="h4"
          align="center"
          style={{ 
              marginBottom: '40px',                
              cursor: 'pointer',
              color: '#ff7504'

          }}
        >
          <a
            onClick={() =>
              (window.location.href = `/ulap-recruit`)
            }
          >
            Learn more...
          </a>
        </Typography>

        <div className={classes.searchContainer} style={{ marginTop: '10px' }}>
          <TextField
            label="What are you looking for?"
            variant="outlined"
            size="normal"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{ width: '100%' }}
            InputProps={{
              style: { borderRadius: '30px' },
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </div>

        <div className={classes.gridContainer}>
          {paginatedData.map((row, index) => (
            <Card
              key={index}
              className={classes.card}
              onClick={() => handleCardClick(row)}
            >
              <img
                src={row.image || defaultImages[index % defaultImages.length]}
                alt="Image"
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
              />
              <Box
                position="absolute"
                top={12}
                left={12}
                bgcolor="#ffffffdd"
                px={2}
                py={0.5}
                borderRadius={16}
                zIndex={2}
              >
                <Typography variant="caption" fontWeight="bold">
                  {row.jDate
                    ? new Date(row.jDate).toLocaleDateString()
                    : 'DATE POSTED'}
                </Typography>
              </Box>
              <CardContent
                style={{
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  borderBottomLeftRadius: 16,
                  borderBottomRightRadius: 16,
                  height: '40%',
                  padding: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <Typography variant="h6" component="h2" gutterBottom>
                  {' '}
                  <b>{row.Name}</b>
                </Typography>
                {row.Particulars && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginBottom: '10px' }}
                  >
                    {row.Particulars.length > 80
                      ? `${row.Particulars.substring(0, 60)}...`
                      : row.Particulars}
                  </Typography>
                )}
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: 20, fontSize: '0.8rem' }}
                    onClick={e => {
                      e.stopPropagation();
                      handleCardClick(row);
                    }}
                    endIcon={<LaunchIcon />}
                  >
                    View
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
          {placeholders.map((_, index) => (
            <div
              key={`placeholder-${index}`}
              style={{
                borderRadius: 16,
                height: 300,
                backgroundColor: 'transparent'
              }}
            />
          ))}
        </div>
        {filteredData.length > itemsPerPage && (
          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={Math.ceil(filteredData.length / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              style={{ margin: '20px 0' }}
            />
          </Box>
        )}
      </Container>
    </div>
  );
};

export default JobPagesPublic;
